exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.colorPicker[data-v-68b7c4fa] {\n  position: relative;\n}\n.colorPicker .colorBall[data-v-68b7c4fa] {\n    width: 24px;\n    height: 24px;\n    border-radius: 50%;\n    margin: 3px;\n    border-width: 3px;\n    border-style: solid;\n}\n.colorPicker .currentColor[data-v-68b7c4fa] {\n    padding: 3px 12px;\n}\n.colorPicker .swatch[data-v-68b7c4fa] {\n    position: absolute;\n    left: 0;\n    top: 100%;\n    margin-top: 5px;\n    z-index: 10;\n    padding: 12px;\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-68b7c4fa","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/tools/ColorPicker.vue
// module id = 1542
// module chunks = 0